import React from 'react';
import { NuvoCheckbox } from '@nuvolo/nuux-core/components/NuvoCheckbox';
import { FilterGroupItem } from '../ListProps';
import { FilterChip } from '../util';
import FilterGroupProps from './FilterGroupProps';

export type CheckboxDataSource = FilterGroupItem[];

export type CheckboxDsType = {
  type: 'checkbox';
  dataSource: CheckboxDataSource;
};

export type CheckboxFilterGroupProps = FilterGroupProps<CheckboxDsType>;

const CheckboxFilterGroup: React.FC<CheckboxFilterGroupProps> = ({
  group,
  filters,
  onFilterChange,
}) => {
  const items = group.dataSource;
  if (!items.length) return null;

  return (
    <>
      <div className="filter-panel-section-title">{group.label}</div>

      {items.map((item) => {
        const chip: FilterChip = {
          dataField: group.dataField,
          label: item.label,
          value: item.value ?? null,
          customColors: item.customColors,
        };

        const isSelected = filters.some((x) => x.value === chip.value);

        return (
          <div
            key={item.value ?? item.label}
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: 8,
            }}
            onClick={() => {
              const otherFilters = filters.filter((f) => f.value !== item.value);

              if (isSelected) {
                // deselect
                onFilterChange(otherFilters);
              } else {
                // select
                onFilterChange([...otherFilters, chip]);
              }
            }}>
            <NuvoCheckbox value={isSelected} text={item.label} />
          </div>
        );
      })}
    </>
  );
};

export default CheckboxFilterGroup;
